import axios from 'axios';
import { useCallback, useEffect, useState } from 'react'

const useFetch = (url,autoLoad=true) => {
    const [data,setData] = useState(null);
    const [loading,setLoading] = useState(Boolean(autoLoad && url));
    const [error,setError]  = useState(null);

    const fetchData = useCallback(async ()=>{
        if (!url) {
            setLoading(false);
            return;
        }
        setLoading(true);
        const pathSegments = window.location.pathname.split('/').filter(Boolean);
        const tokenIndex = pathSegments.indexOf('token');
        const tokenFromPath = tokenIndex > -1 && pathSegments[tokenIndex + 1]
            ? decodeURIComponent(pathSegments[tokenIndex + 1])
            : null;
        let token = tokenFromPath || localStorage.getItem('token');
        if (!token) {
            await new Promise((resolve) => setTimeout(resolve, 250));
            token = tokenFromPath || localStorage.getItem('token');
        }
        const headers = token
            ? { Authorization: `Bearer ${token}` }
            : {};
        try {
            const response = await axios.get(url,{
                headers
            });
            setData(response.data);
            setError(null);
            setLoading(false);
        }catch(error){
            setError(error);
            setLoading(false);
        }
    },[url]);

    const refreshHandler = useCallback(() => {
        fetchData();
    }, [fetchData]);

    useEffect(()=>{
        if(autoLoad && url){
            fetchData();
        }
    },[autoLoad, url, fetchData])

    return {data,loading,error,fetchData,refreshHandler}
}

export default useFetch
